module.exports = __webpack_public_path__ + "static/media/itineraryLogo.a175b6ef.png";